module.exports = class GatewaysFormCtrl
  constructor: ->
    'ngInject'

  submit: ->
    @onSubmit()
